module.exports = __webpack_public_path__ + "static/media/trust_payments.d801dce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/secure_trading/trust_payments.png
// module id = 646
// module chunks = 0